import {
  DataBag,
  DataBagAction,
  ArrayOperationType,
  DatabagActionDescriptor,
} from './reducer';
import { Observable } from 'rxjs';
import { GeneralAction } from './actions';
import { Action, Store, select } from '@ngrx/store';
import { getDataBagValue } from './selectors';
import { Injectable } from '@angular/core';

export enum RequestType {
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
  DELETE = 'delete',
}

@Injectable()
export class StoreService {
  isTherePendingRequest = false;
  pendingRequests: GeneralAction[] = [];

  constructor(private store: Store<{ databag: DataBag }>) {}

  setLoading(path: string) {
    this.set(path + '-loading', true);
  }

  resetLoading(path: string) {
    this.set(path + '-loading', false);
  }

  componentMessage(component: string, body: any) {
    let bodyToSend: any;
    if (typeof body == 'object') {
      bodyToSend = JSON.parse(JSON.stringify(body));
    } else {
      bodyToSend = body;
    }

    this.set('ComponentMessage', {
      id: this.random,
      component,
      body: bodyToSend,
    });
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  storeAction(action: DatabagActionDescriptor, data?: any) {
    this.set(action.path, this.substituteInObject(action.value, data));
  }

  set<T>(path: string, value: T) {
    if (typeof value == 'object') {
      // console.log('db-set', value);
    }
    this.store.dispatch(new DataBagAction({ path, value }));
  }

  reset<T>(path: string) {
    this.store.dispatch(new DataBagAction({ path, value: false }));
  }

  flip(path: string) {
    this.store.dispatch(new DataBagAction({ path, flip: true }));
  }

  get<T extends {}>(path: string): Observable<T> {
    return this.store.pipe(select(getDataBagValue, { path }));
  }

  async getSync<T extends any>(path: string) {
    return new Promise<T>(resolve =>
      this.get(path).subscribe((val: T) => {
        if (val) {
          resolve(val);
        }
      }),
    );
  }

  push<T>(path: string, value: T) {
    this.store.dispatch(
      new DataBagAction({
        path,
        value,
        arrayOperation: ArrayOperationType.Push,
      }),
    );
  }

  substituteInObject(object: Record<string, any>, data: any) {
    if (!data) {
      return object;
    }
    Object.entries(object || {}).map(([key, value]) => {
      if (typeof value === 'object') {
        this.substituteInObject(value, data);
      }
      if (value === '${data}') {
        object[key] = data;
      }
    });
    return object;
  }

  private get random() {
    return Math.random().toString().slice(2);
  }
}
